import { createTheme } from '@mui/material/styles'
import colors from './colors'

export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: colors.blue[900],
      contrastText: '#FFFFFF',
    },
    text: {
      primary: '#091E42',
    },
  },
  typography: {
    fontFamily: ['Roboto', 'sans-serif'].join(','),
  },
  components: {
    MuiButton: {
      variants: [
        {
          props: { variant: 'contained' },
          style: {
            border: `1px solid ${colors.neutral[40]}`,
            borderRadius: '6px',
            color: colors.neutral[0],
            boxShadow: 'unset',
            '&:hover': {
              backgroundColor: colors.blue[800],
              boxShadow: 'unset',
            },
            '&:active': {
              boxShadow: 'unset',
            },
            '&:focus': {
              backgroundColor: colors.blue[800],
              boxShadow: 'unset',
            },
            '&:disabled': {
              color: colors.neutral[100],
              backgroundColor: colors.neutral[40],
              boxShadow: 'unset',
            },
          },
        },
      ],
    },
  },
})
